var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BarGraphVertical',{attrs:{"data":_vm.upperData,"types":_vm.types}}),_c('BarGraphVertical',{attrs:{"data":_vm.lowerData,"types":_vm.types,"negative":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }